


export const BASE_URL = 'https://backend.carepay.money'

export const APIS ={

      LOGIN_MERCHANT: (doctorCode, password) =>
    `${BASE_URL}/loginWithPassword?doctorCode=${encodeURIComponent(
      doctorCode
    )}&password=${encodeURIComponent(password)}`,
      GET_MONTHLY_LEADS: (doctorId) =>
    `${BASE_URL}/getMonthlyLeadsPerClinicDoctor?doctorId=${doctorId}&clinicName=
    `,
      GET_LOAN_AMOUNT: (doctorId,st,ed) =>
    `${BASE_URL}/getLoanCountAndAmountForDoctor?doctorId=${doctorId}&clinicName=&startDate=${st}&endDate=${ed}`,
      GET_QR: () =>
    `${BASE_URL}/getQrCode?doctorId=${localStorage.getItem("doctorId")}`,
      GET_DOCTOR_DETAILS: () =>
    `${BASE_URL}/getDoctorDetailsByDoctorId?doctorId=${localStorage.getItem("doctorId")}`,
      GET_ALL_CLINIC: () =>
    `${BASE_URL}/getAllChildClinic?doctorId=${localStorage.getItem("doctorId")}`,
    //   GET_GRAPH_PARENT: (parentDoctorId,type,loanStatus) =>
    // `${BASE_URL}/getTrendGraphForParentDoctor?parentDoctorId=${parentDoctorId}&type=${type}&loanStatus=${loanStatus}&startDate=&endDate=&clinicName=null`,
      GET_GRAPH_PARENT: (parentDoctorId,st,ed,type,loanStatus) =>
    `${BASE_URL}/getTrendGraphForParentDoctor?parentDoctorId=${parentDoctorId}&type=${type}&loanStatus=${loanStatus}&startDate=${st}&endDate=${ed}&clinicName=null`,
      GET_GRAPH_CHILD: (doctorId,st,ed,type,loanStatus) =>
    `${BASE_URL}/getTrendGraphForDoctor?doctorId=${doctorId}&type=${type}&loanStatus=${loanStatus}&startDate=${st}&endDate=${ed}`,
      DOWNLOAD_MIS_REPORT: (sDate, eDate, doctorCode, type = 'all') =>
    `${BASE_URL}/downloadDoctorMISReport?sDate=${encodeURIComponent(sDate)}&eDate=${encodeURIComponent(eDate)}&doctorCode=${encodeURIComponent(doctorCode)}&type=${encodeURIComponent(type)}`,
      GET_DOCTOR_DASHBOARD_DATA: (doctorId, startDate, endDate) =>
    `${BASE_URL}/getDoctorDashboardData/?doctorId=${encodeURIComponent(doctorId)}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
}